export default "__VITE_ASSET__gL$E$Rqq__"